const routers: any[] = [
  {
    title: '耐恒',
    path: '/',
    name: 'home',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/home.vue')
  },
  {
    title: '耐恒',
    path: '/childList',
    name: 'childList',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/childList.vue')
  },
  {
    title: '耐恒',
    path: '/search',
    name: 'search',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/search.vue')
  },
  {
    title: '耐恒',
    path: '/postlockstar',
    name: 'postlockstar',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/postlockstar.vue')
  },
  {
    title: '联系我们',
    path: '/contactUs',
    name: 'contactUs',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/form/ContactUs.vue')
  },
  {
    title: '成功案例',
    path: '/case',
    name: 'case',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/case.vue')
  },
  {
    title: '离型知识',
    path: '/faq',
    name: 'faq',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/faq.vue')
  },
  {
    title: '离型知识',
    path: '/faqDis',
    name: 'faqDis',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/faqDis.vue')
  },
  {
    title: '个人中心',
    path: '/userCenter',
    name: 'userCenter',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/userCenter.vue')
  },
  {
    title: '成功案例',
    path: '/caseDis',
    name: 'caseDis',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/caseDis.vue')
  },
  {
    title: '解决方案',
    path: '/solution',
    name: 'solution',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/solution.vue')
  },
  {
    title: '解决方案',
    path: '/solutionDis',
    name: 'solutionDis',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/solutionDis.vue')
  },
  {
    title: '提交成功',
    path: '/result',
    name: 'result',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/form/result.vue')
  },
  {
    title: '会员注册',
    path: '/MemberRegister',
    name: 'MemberRegister',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/form/MemberRegister.vue')
  },
  {
    title: '关于耐恒',
    path: '/about',
    name: 'about',

    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/index.vue')
  },
  {
    title: '编辑信息',
    path: '/EditRegister',
    name: 'EditRegister',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/form/EditRegister.vue')
  },
  {
    title: '我要提问',
    path: '/AskQuestion',
    name: 'AskQuestion',
    meta: {
      // keepAlive: true,// 是否需要开启页面缓存
      wechatAuth: true,// 是否开启微信授权
      
      // 注意改示例是关闭了页面监测
      closeMonitorView: true,// 是否关闭页面浏览监测，自定义页面标题使用
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/form/AskQuestion.vue')
  },

];

export default routers;
